import React from 'react'
import { useAuth } from '../../hooks/useAuth'

interface Props {
	children: any
	[key: string]: any
	keyPath?: (string | number)[]
	formState?: any
	setFormState?: Function
	name?: string
	onChange?: (e: React.FocusEvent<HTMLSelectElement>) => void
	value?: any
	isBool?: Boolean
	disabledPrio?: Boolean
}
const Select = ({
	children,
	keyPath,
	formState,
	setFormState,
	name,
	onChange,
	value,
	isBool,
	disabledPrio,
	...rest
}: Props) => {
	const auth = useAuth()
	const o = auth.userDTO?.teams?.[keyPath ? (keyPath[0] as string) : '']
	const initValue: any = auth.userDTO?.teams
	const valueFromKeyPath = keyPath?.reduce((acc, key) => acc?.[key], initValue)
	let value2: any
	if (formState && name) {
		value2 = formState[name]
	} else if (keyPath && isBool) {
		value2 = valueFromKeyPath ? 1 : 0
	} else if (keyPath) {
		value2 = valueFromKeyPath
	}
	return (
		<select
			className={'input-select'}
			value={value ?? value2}
			onChange={(e: React.FocusEvent<HTMLSelectElement>) => {
				const { value } = e.target
				let i = parseInt(value)
				if (onChange) {
					onChange?.(e)
				} else if (formState && setFormState && name) {
					setFormState({
						...formState,
						[name]: value,
					})
				} else if (keyPath) {
					if (isBool && !isNaN(i)) {
						auth.updateClientAndServer({
							keyPath: keyPath,
							value: i == 1 ? true : false,
							operation: 'setValue',
						})
					} else {
						auth.updateClientAndServer({
							keyPath: keyPath,
							value,
							operation: 'setValue',
						})
					}
				}
			}}
			disabled={
				(o && o?.scope?.range != 'all' && !auth?.userDTO?.isTikexAdmin) ||
				disabledPrio == true
			}
		>
			{children}
		</select>
	)
}

export default Select
